<template>
  <section>
    <b-navbar toggleable="lg" class="submenu">
      <b-nav>
        <add-service @addedService="addedService">
          <b-nav-item>
            <i class="fal fa-plus-circle" />
            <span>{{ $t('SERVICES.ADD_SERVICE') }}</span>
          </b-nav-item>
        </add-service>
        <b-nav-item
          :active="selected === 0"
          @click="setActive(0)"
          v-b-tooltip.hover
          :title="$t('SERVICES.ACTIVE')"
        >
          <i class="fal fa-cubes" />
          <span>{{ $t('SERVICES.ACTIVE') }}</span>
        </b-nav-item>
        <b-nav-item
          :active="selected === 1"
          @click="setActive(1)"
          v-b-tooltip.hover
          :title="$t('SERVICES.ARCHIVED')"
        >
          <i class="fal fa-archive" />
          <span>{{ $t('SERVICES.ARCHIVED') }}</span>
        </b-nav-item>
      </b-nav>
    </b-navbar>

    <div class="container-fluid mt-2">
      <b-form class="mb-3">
        <b-form-input class="i-100" v-model="searchText" :placeholder="$t('SEARCH')"></b-form-input>
      </b-form>

      <div v-for="(groupedItems, index) in groupedList" v-bind:key="index" class="row">
        <div v-for="(item, itemindex) in groupedItems" v-bind:key="itemindex" class="col-lg-6">
          <services-item :item="item" :key="item.id" @updated="updatedService" @removed="removedService" />
        </div>
      </div>

      <b-card v-if="items.length === 0" no-body class="mt-2">
        <b-card-body class="m-4">{{ $t('SERVICES.NO_SERVICES')}}</b-card-body>
      </b-card>

      <b-pagination
      v-model="currentPage"
      :total-rows="totalItems"
      :per-page="limit"
      align="center"
      @input="getServices"
    >
      <template v-slot:first-text>{{$t("PAGINATION.FIRST")}}</template>
      <template v-slot:prev-text>{{$t("PAGINATION.PREV")}}</template>
      <template v-slot:next-text>{{$t("PAGINATION.NEXT")}}</template>
      <template v-slot:last-text>{{$t("PAGINATION.LAST")}}</template>
    </b-pagination>
    </div>
  </section>
</template>
<script>
import ServicesItem from "@/components/Services/ServicesItem";
import AddService from "@/components/Services/AddService";
import _ from "lodash";
export default {
  components: {
    ServicesItem,
    AddService
  },
  data() {
    return {
      modalSectionAdd: false,
      selected: 0,
      sectionName: "",
      searchText: "",
      currentPage: 1,
      limit: 6,
      items: [],
      totalItems: 0,
      user: this.$store.state.auth.user
    };
  },
  methods: {
    setActive(selected) {
      this.selected = selected;
      this.getServices();
    },
    showAddSection() {
      this.modalSectionAdd = true;
    },
    hideAddSection() {
      this.modalSectionAdd = false;
      this.sectionName = "";
    },
    addedService() {
      this.getServices();
    },
    getServices: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/services/list", {
          page: this.currentPage,
          archived: this.selected,
          limit: this.limit,
          searchText: this.searchText
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    },
    addService: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/services/add", {
          name: this.sectionName
        })
        .then(response => {
          self.items.push(response.data);
          self.items.totalItems = self.items.total + 1;
          self.hideAddSection();
        })
        .catch(error => {
          self.$noty.error(self.$t(error.data.message));
        });
    },
    updatedService: function(updatedInformation) {
      for (let ix = 0; ix < this.items.length; ix++) {
        if (this.items[ix].id === updatedInformation.id) {
          if (this.selected !== updatedInformation.archived) {
            this.items.splice(ix, 1);
          } else {
            this.items[ix] = updatedInformation;
          }
        }
      }
    },
    removedService: function(updatedInformation) {
      for (let ix = 0; ix < this.items.length; ix++) {
        if (this.items[ix].id === updatedInformation.id) {
          this.items.splice(ix, 1);
        }
      }
    }
  },
  computed: {
    groupedList() {
      return _.chunk(this.items, 2);
    }
  },
  watch: {
    searchText: function() {
      if (this.searchText.length == 0) {
        this.getServices();
      }
      if (this.searchText.length >= 3) {
        this.getServices();
      }
    }
  },
  mounted: function() {
    this.getServices();
  }
};
</script>
<style>
</style>